import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { allRoutes } from '../../app/routeConfig';
import { useAuth } from '../../core/auth/AuthContext';
import { getFirstAccessiblePath } from '../../core/utils/routeAccess';

export default function UnauthorizedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleBack = () => {
    const path = getFirstAccessiblePath(user, allRoutes);
    if (path) {
      navigate(path, { replace: true });
      return;
    }
    logout();
  };

  return (
    <Result
      status="403"
      title={t('unauthorized.title')}
      subTitle={t('unauthorized.message')}
      extra={<Button type="primary" onClick={handleBack}>{t('common.back')}</Button>}
    />
  );
}
